<template>
  <div class="container">
    <div class="intro">本店({{schoolName}})目前支持的配送楼栋如下：</div>
    <div class="builds"  v-if="buildsList.length > 0"  >
      <div v-for="item in buildsList"   class="builds">{{item.area}}<span v-if="item.msg">{{item.msg}}</span></div>
    </div>
    <div v-else class="ac">暂无楼栋</div>
  </div>

</template>

<script>
    import {actions} from "../store/actions";

    export default {
      name: "findBuild",
      data(){
         return {
           buildsList: [],
           schoolName: this.$store.state.schoolInfo.schoolName,
           charge_per_floor: 0,
         }
      },
      computed: {
        schoolInfo () {
          return this.$store.state.schoolInfo
        },
      },
      created () {
        var _this = this;
        _this.getBuildingList();
      },
      methods: {
        getBuildingList () {
          let _this = this;
          let orderPreviewInfo = JSON.parse(window.localStorage.getItem('orderPreviewInfo'));
          _this.charge_per_floor = orderPreviewInfo.isCanChooseDeliveryWay
          let params = {
            school_id: this.$store.state.schoolInfo.schoolId,
            shop_id: window.localStorage.getItem('shop_code'),
            charge_per_floor: _this.charge_per_floor
          }
          actions.postBuildLists(_this, params, data => {
            if (data && data.length > 0) {
            _this.buildsList = data;
            }
          })
        },
      }
    }
</script>

<style scoped>
  .container{
    padding: .05rem .20rem;
  }
  .intro{
    font-size: .32rem;
    margin-bottom: .20rem;
    font-weight: bold;
  }
  .builds{
    font-size: .28rem;
    line-height: .70rem;
    border-bottom: .5px solid #f5f5f5;
  }
</style>



// WEBPACK FOOTER //
// FindBuild.vue?524b5b73